/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useEffect, useContext } from 'react';
import { Collapse, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import moment from 'moment';
import Toggle from 'react-toggle';
import Alert from 'react-s-alert';
import "react-toggle/style.css";

// context imports
import { ThemeContext } from '../../../contexts/ThemeContext';
import { AuthContext } from '../../../contexts/AuthContext';

// service imports
import ProviderService from '../../../services/ProviderService';
import GeneralService from '../../../services/GeneralService';

// local imports
import FullPageLoader from '../../general/FullPageLoader';
import RescheduleSession from './RescheduleSession';
import { counsellors, siteVariable } from '../demoData';

const AvailableDays = props => {

    // contexts
    const { theme, fontSize, colors } = useContext(ThemeContext);
    const { selectedTimeZone } = useContext(AuthContext);

    // states
    const [modal, setModal] = useState({
        visible: false,
        sessions: []
    });
    const [isAvailableDaysOpen, setIsAvailableDaysOpen] = useState(true);
    const [timeSlotSize, setTimeSlotSize] = useState(0);
    const [availableDaysAndBookings, setAvailableDaysAndBookings] = useState([]);
    const [listOfDateAndSlots, setListOfDateAndSlots] = useState([]);
    const [isLoading, setIsLoading] = useState([]);
    const [loading, setLoading] = useState(true);

    // useEffects
    // useEffect(() => {
    //     getAvailableDaysAndBookings();
    // }, []);
    const getSlots = async (availableTimes, timeZone, j, size) => {
        let listOfSlots = [];
        await Promise.all(
            availableTimes.map(async (item, index) => {
                let tempFrom = moment().utcOffset(timeZone).add(j + 1, 'day').set({ hour: moment(item.from).utcOffset(timeZone).get('hour'), minute: moment(item.from).utcOffset(timeZone).get('minute'), second: 0, millisecond: 0 });
                let tempTo = moment().utcOffset(timeZone).add(j + 1, 'day').set({ hour: moment(item.to).utcOffset(timeZone).get('hour'), minute: moment(item.to).utcOffset(timeZone).get('minute'), second: 0, millisecond: 0 });
                let slots = listOfSlots;
                while (!tempFrom.isSame(tempTo)) {
                    let slot = { from: "", to: "", availableStatus: Math.random() * 10 > 8 ? false : true };
                    slot.from = tempFrom.toISOString();
                    tempFrom = moment(tempFrom).set({ second: 0, millisecond: 0 }).add(size, 'minutes');
                    slot.to = tempFrom.toISOString();
                    slots.push(slot);
                }
                listOfSlots = slots;
            })
        )
        return listOfSlots;
    }

    useEffect(() => {
        try {
            //calling getAvailableDaysAndBooking when availableTimings get updated
            setLoading(true);
            getAvailableDaysAndBookings(props.doRefresh.updatedSlots);
            setLoading(false);
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Provider AvailableDays useEffect', 'Error in try catch block', err.stack);
        }
    }, [props.doRefresh.status])

    const getAvailableDaysAndBookings = (slots) => {
        setLoading(true);
        let tempSlots = slots.length ? slots : counsellors[0].availableTimes;
        let listOfAvailableDaysAndBookings = [];
        Promise.all([...Array(siteVariable.advanceBookingLimit)].map(async (item, j) => {
            let slotsToAdd = await getSlots(tempSlots, counsellors[0].timeZone, j, siteVariable.timeSlotSize);
            listOfAvailableDaysAndBookings = listOfAvailableDaysAndBookings.concat(slotsToAdd);
        })).then(() => {
            // console.log(data);
            setAvailableDaysAndBookings(listOfAvailableDaysAndBookings);
            setTimeSlotSize(siteVariable.timeSlotSize);
            createSlots(listOfAvailableDaysAndBookings);
            // initializing spinners
            let tempSpinners = [];
            for (let i = 0; i < listOfAvailableDaysAndBookings.length; i++) {
                tempSpinners.push(false);
            }
            setIsLoading(tempSpinners);
            setLoading(false);
        });
    }

    const toggleAvailableDays = () => setIsAvailableDaysOpen(!isAvailableDaysOpen);

    const createSlots = (list) => {
        let slots = [];
        let dateSlots = [];
        let rangeIndex = 1;
        dateSlots.push({ isExtra: true, value: rangeIndex });
        dateSlots.availableStatus = false;
        let date = "";
        Promise.all(
            list.map((item, index) => {
                // if (item.availableStatus && item.from) {
                if (date === "") {
                    date = moment(item.from).utcOffset(selectedTimeZone.isDST ? selectedTimeZone.dst_offset : selectedTimeZone.offset).format("DD-MM-YYYY");
                } else if (date !== moment(item.from).utcOffset(selectedTimeZone.isDST ? selectedTimeZone.dst_offset : selectedTimeZone.offset).format("DD-MM-YYYY")) {
                    slots.push(dateSlots);
                    date = "";
                    dateSlots = [];
                    rangeIndex = 0;
                } else if (index === (list.length - 1)) {
                    slots.push(dateSlots);
                }
                if (item.availableStatus === true) {
                    dateSlots.availableStatus = true;
                }
                if (index > 0 && moment(list[index - 1].to).diff(moment(item.from), 'minute') !== 0) {
                    rangeIndex = rangeIndex + 1;
                    dateSlots.push({ isExtra: true, value: rangeIndex });
                }
                dateSlots.push(item);
                // }
            })
        ).then(() => {
            // console.log("here", slots);
            if (slots.length) {
                slots[0].isOpen = true;
            }
            setListOfDateAndSlots(slots);
        })
    }

    // handle functions
    const handleToggle = (type, value, dateIndex, timeIndex) => {
        try {
            let updatedSlots = [];
            if (type === "date") {
                listOfDateAndSlots[dateIndex].map((item) => {
                    updatedSlots.push({ id: item._id, value: value });
                })
            } else {
                updatedSlots.push({ id: listOfDateAndSlots[dateIndex][timeIndex]._id, value: value });
            }
            // // show spinner
            // setIsLoading({ ...isLoading, [index]: true });

            // post request
            setTimeout(() => {
                // stop spinner
                // setIsLoading({ ...isLoading, index: false });
                let tempArray = [...listOfDateAndSlots];
                if (type === "date") {
                    tempArray[dateIndex].availableStatus = false;
                    tempArray[dateIndex].map((item, index) => {
                        if ([].findIndex(bookedSlot => bookedSlot._id.toString() === tempArray[dateIndex][index]._id.toString()) === -1) {
                            tempArray[dateIndex][index].availableStatus = value;
                        }
                        if (item.availableStatus === true) {
                            tempArray[dateIndex].availableStatus = true;
                        }
                    })
                } else {
                    if ([].findIndex(bookedSlot => bookedSlot._id.toString() === tempArray[dateIndex][timeIndex]._id.toString()) === -1) {
                        tempArray[dateIndex][timeIndex].availableStatus = value;
                    }
                    tempArray[dateIndex].availableStatus = false;
                    tempArray[dateIndex].map((item) => {
                        if (item.availableStatus === true) {
                            tempArray[dateIndex].availableStatus = true;
                        }
                    })

                }
                setListOfDateAndSlots(tempArray);
                Alert.info("Successfully updated available days and timings", {
                    position: 'top-right',
                    effect: 'slide'
                });
            }, [1000]);
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Provider AvailableDays handleToggle', 'Error in try catch block', err.stack);
        }
    }

    const toggleDateCard = (index) => {
        try {
            let arrayDuplicate = [...listOfDateAndSlots];
            arrayDuplicate[index].isOpen = !arrayDuplicate[index].isOpen;
            setAvailableDaysAndBookings(arrayDuplicate);
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Provider AvailableDays toggleDateCard', 'Error in try catch block', err.stack);
        }
    }

    return (
        loading ?
            <FullPageLoader /> :
            <div className="p-3 mt-3" style={theme.card}>
                <div className="row px-3" onClick={toggleAvailableDays} style={{ cursor: "pointer" }}>
                    <span style={theme.headingBold}>Status for upcoming days</span>
                    <span className="ml-auto" style={theme.headingRegular}>
                        {
                            isAvailableDaysOpen
                                ? <span className="ml-3"><i className="fas fa-angle-up"></i></span>
                                : <span className="ml-3"><i className="fas fa-angle-down"></i></span>
                        }
                    </span>
                </div>


                <Collapse isOpen={isAvailableDaysOpen}>
                    <hr />
                    <div>
                        {
                            listOfDateAndSlots.length > 0
                                ?
                                listOfDateAndSlots.map((item1, index1) => (
                                    <div key={index1} className="p-3 mt-3" style={theme.card}>
                                        <div className="row px-3" onClick={() => toggleDateCard(index1)} style={{ cursor: "pointer" }}>
                                            <span className="mr-3" style={theme.headingBold}>{moment(item1[1].from).utcOffset(selectedTimeZone.isDST ? selectedTimeZone.dst_offset : selectedTimeZone.offset).format("DD-MM-YYYY")}</span>
                                            <div id={`availableDates${index1}`}>
                                                <Toggle
                                                    id={index1.toString()}
                                                    className="mr-3"
                                                    icons={false}
                                                    checked={item1.availableStatus}
                                                    onChange={(e) => handleToggle("date", e.target.checked, index1, undefined)}
                                                />
                                            </div>
                                            {
                                                item1.findIndex(slotItem => (!slotItem.isExtra && !slotItem.availableStatus)) > -1 ? <i className="fas fa-circle fa-xs my-auto" style={{ color: colors.danger }}></i> : null
                                            }
                                            {
                                                item1.isOpen
                                                    ? <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-up"></i></span>
                                                    : <span className="ml-auto" style={theme.headingRegular}><i className="fas fa-angle-down"></i></span>
                                            }

                                        </div>

                                        <Collapse isOpen={item1.isOpen}>
                                            <hr />
                                            <div className="row px-3 justify-content-md-start justify-content-sm-between justify-content-between">
                                                {
                                                    item1.map((item, index) => (
                                                        item.isExtra ?
                                                            <div key={index} id={`extraSlot${index1}-${index}`} className="col-12 mt-3" style={theme.extraSlotCard}>
                                                                <span><span style={theme.paragraphMedium}>Time Range -</span> {item.value}</span>
                                                                <hr className="p-0 mt-0 mb-1" />
                                                            </div>
                                                            :
                                                            <div key={index} id={`slot${index1}-${index}`} className="col-sm-5 col-5 col-md-2 m-2 text-center py-5" style={(item.isLocked || item.isBooked) ? theme.disabledSlotCard : theme.slotCard}>
                                                                <div id={`availableSlots${index1}-${index}`} style={{ position: "absolute", top: "8px", right: "8px" }}>
                                                                    <Toggle
                                                                        id={`${index1}-${index}`}
                                                                        className="ml-3"
                                                                        icons={false}
                                                                        checked={item.availableStatus}
                                                                        onChange={(e) => handleToggle("slot", e.target.checked, index1, index)}
                                                                    />
                                                                </div>
                                                                <span>{`${moment(item.from).utcOffset(selectedTimeZone.isDST ? selectedTimeZone.dst_offset : selectedTimeZone.offset).set({ second: 0, millisecond: 0 }).format("hh:mm A")} - ${moment(item.to).utcOffset(selectedTimeZone.isDST ? selectedTimeZone.dst_offset : selectedTimeZone.offset).set({ second: 0, millisecond: 0 }).format("hh:mm A")}`}</span>
                                                            </div>
                                                    ))
                                                }
                                            </div>
                                        </Collapse>

                                    </div>
                                ))
                                :
                                <h3>No slots available on this day</h3>
                        }

                        <p className="mt-5" style={theme.paragraph}>*The status can be changed only if there is no session booked on that day</p>
                    </div>
                </Collapse>

                <Modal size="lg" isOpen={modal.visible} backdrop={true}>
                    <ModalHeader close={<span className="ml-3" style={{ cursor: "pointer" }} onClick={() => setModal({ visible: false, sessions: [] })}><i className="fas fa-times"></i></span>}><span style={theme.headingBold}>Sessions Scheduled on this day</span></ModalHeader>
                    <ModalBody className="p-3 mt-3">
                        <RescheduleSession sessions={modal.sessions} closeModel={() => setModal({ visible: false, sessions: [] })} />
                    </ModalBody>
                </Modal>

            </div>
    )
}

export default AvailableDays;